import { environment } from "../../environment/environment";
import EditorCk from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { useEffect, useRef } from "react";


const Editor = (props) => {
    const ckRef = useRef(null);
    const editorConfiguration = {
        toolbar: 
        {
        shouldNotGroupWhenFull: true
        },
        extraPlugins: [ uploadPlugin ],
        language: {
            // The UI will be English.
            ui: 'en',

            // But the content will be edited in Arabic.
            content: 'fa'
        }
    };    
    function uploadAdapter(loader) { 
        return {
            upload : () => {
                return new Promise((resolve , reject) => {
                    const body = new FormData();
                    loader.file.then((file)=> {
                        body.append("uploadImg", file);
                        fetch(environment.baseUrl+"BaseData/uploadEditorImage" , {
                            method:"post" , 
                            body:body
                        })
                        .then((res)=>{
                            return res.text();
                        })
                        .then((res)=>{
                            resolve({default:res})
                        })
                        .catch((err)=>{
                            reject(err);
                        })
                    })
                })
            }
        }
    }

    function uploadPlugin(editor) {
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
            return  uploadAdapter( loader );
        };
    }



    return (
        <CKEditor
        editor={ EditorCk }
        onReady={ editor => {
            if(props.value) {
                editor.data.set(props.value);
            }
        } }
        ref={ckRef}
        data={props.value}
        config={ editorConfiguration }
        onChange={props.onChange}
    />


    )
}

export default Editor;